import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SplashComponent }   from './splash/splash.component';
import { TagComponent }   from './tag/tag.component';
import { CoursesComponent }   from './courses/courses.component';
import { CourseDetailComponent }   from './course-detail/course-detail.component';
import { CourseDetailResolve }   from './course-detail/course-detail.resolve';
import { SavedTagsComponent }   from './saved-tags/saved-tags.component';

const routes: Routes = [
    { path: '', component: SplashComponent},
    { path: 'tag-list', component: TagComponent},
    { path: 'saved/:ids', component: SavedTagsComponent},   
    { path: 'courses/:type', component: CoursesComponent},
    { path: 'course-detail/:id', component: CourseDetailComponent, resolve: {courseDetail: CourseDetailResolve}},
    { path: 'saved', redirectTo: '/'},
    { path: '**', redirectTo: '/'}
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}


/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/app-routing.module.ts